
import {Component, Prop, Vue} from "vue-property-decorator";
import {IDataFieldDeletionReport} from "@/auxillary/datafield.deletion";
import {isBranchingFieldType, isParentFieldType} from "@/auxillary/datafield.cache.helpers";
import {stringify} from "@/auxillary/datafield.stringify";

@Component
export default class DeletedDataField extends Vue {
  @Prop({required: true}) deletedDataFieldReport!: IDataFieldDeletionReport;

  get hasIcon() {
    return this.fieldValueWillBeDeleted || this.fieldDeletionWillBeUndone;
  }

  get icon() {
    if (this.fieldDeletionWillBeUndone)
      return "fa-undo";
    if (!this.fieldDeletionWillBeUndone && this.fieldValueWillBeDeleted)
      return "fa-trash-alt";
    return "";
  }

  get dataFieldCache() {
    return this.deletedDataFieldReport.dataFieldCache;
  }

  get displayName() {
    return this.dataFieldCache.displayName;
  }

  get displayValue() {
    return isParentFieldType(this.definitionType) ? "" : " " + stringify(this.dataFieldCache) ?? "";
  }

  get definitionType() {
    return this.dataFieldCache.definitionType ?? "";
  }

  get isListEntry() {
    return isBranchingFieldType(this.definitionType);
  }

  get fieldValueWillBeDeleted() {
    return this.deletedDataFieldReport.fieldValueWillBeDeleted;
  }

  get fieldDeletionWillBeUndone() {
    return this.deletedDataFieldReport.fieldDeletionWillBeUndone;
  }

  get hasChildFieldsWithValues() {
    return this.deletedDataFieldReport.hasChildFieldsWithValues;
  }

  get deletedChildFields() {
    return this.deletedDataFieldReport.deletedChildFields ?? [];
  }

  get hasChildNames() {
    return isBranchingFieldType(this.dataFieldCache.definitionType);
  }

  get childNames() {
    return this.dataFieldCache.definition.names ?? [{
      template: "{0}",
      field: ["name"]
    }];
  }

  get childName() {
    let name = "";

    for (const childName of this.childNames) {
      // find field
      let field: any = undefined;
      for (const fieldIdentifier of childName.field) {
        if (field === undefined) {
          field = this.dataFieldCache.childFields.find(d => d.identifier == fieldIdentifier)
          if (field === undefined)
            break;
          continue;
        }

        field = field.childFields.find((d: any) => d.identifier == fieldIdentifier)
        if (field === undefined)
          break;
      }
      if (field?.values == null)
        continue;

      const fieldName = stringify(field);
      if (fieldName)
        name += childName.template.replace("{0}", fieldName);
    }

    if (name == "")
      return " (keine Eintragung)";

    return " " + name;
  }


}
